import { render, staticRenderFns } from "./allocations.vue?vue&type=template&id=df3d8f9c&scoped=true&"
import script from "./allocations.vue?vue&type=script&lang=ts&"
export * from "./allocations.vue?vue&type=script&lang=ts&"
import style0 from "./allocations.vue?vue&type=style&index=0&id=df3d8f9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df3d8f9c",
  null
  
)

export default component.exports